<template>
  <div>
    <div
      v-if="profileImage"
      class="profile-image pr-2"
    >
      <v-badge
        bordered
        bottom
        :color="'error'"
        offset-x="13"
        offset-y="13"
        dot
      >
        <v-avatar :width="size">
          <v-img :src="profileImage" />
        </v-avatar>
      </v-badge>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  props: {
    size: {
      type: Number,
      default: 50
    },
    profileImage: {
      type: String,
      default: null
    }
  }
})
export default class Avatar extends Vue {}
</script>
